import React from 'react'
const ContdownTimerRender = ({days, hours, minutes, seconds, completed }) => {
    if (completed) {
        // after time over
        return  <div className="centered ">
        <div className="MENbtn d-flex ">
            <h4 className="text-warning">THE TIME IS OVER</h4>
        </div>
        </div>;
      } else {
        // Render a countdown
        return     <div className="centered ">
        <div className="MENbtn d-flex ">
          <div className="btn-l-1">
            <button className="btn btn-light mx-2 MENbtn-text fw-bold">
              {days}
            </button>
            <br />
            <span className="mx-2 text-light">days</span>
          </div>
          <div className="btn-l-1">
            <button className="None-Btn">-</button>
          </div>
          <div className="btn-l-1">
            <button className="btn btn-light mx-2 MENbtn-text fw-bold">
              {hours}
            </button>
            <br />
            <span className="mx-2 text-light">hours</span>
          </div>
          <div className="btn-l-1">
            <button className="None-Btn">-</button>
          </div>
          <div className="btn-l-1">
            <button className="btn btn-light mx-2 MENbtn-text fw-bold">
              {minutes}
            </button>
            <br />
            <span className="mx-2 text-light">minutes</span>
          </div>
          <div className="btn-l-1">
            <button className="None-Btn">-</button>
          </div>
          <div className="btn-l-1">
            <button className="btn btn-light mx-2 MENbtn-text fw-bold">
              {seconds}
            </button>
            <br />
            <span className="mx-2 text-light">seconds</span>
          </div>
        </div>
      </div>;
      }
}

export default ContdownTimerRender